// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    color: white;
  }
  
  .app-container {
    background-color: #2B2C33;
    min-height: 100vh; /* Ensure the container takes up the full viewport height */
    display: flex;
    flex-direction: column;
  }
  
  /* Additional global styles */
  `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB,EAAE,2DAA2D;IAC9E,aAAa;IACb,sBAAsB;EACxB;;EAEA,6BAA6B","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    font-family: Arial, sans-serif;\n    color: white;\n  }\n  \n  .app-container {\n    background-color: #2B2C33;\n    min-height: 100vh; /* Ensure the container takes up the full viewport height */\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Additional global styles */\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
